export const rowsPerPageOptions = [3, 5, 9, 25, 50, 100, 200, 500, 1000];
//# sourceMappingURL=rowsPerPageOptions.js.map